module.exports = __webpack_public_path__ + "static/media/29BDOS26.d7ceccad.jpg";